var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-externals"},[_c('p',[_vm._v(" Shared with you by "+_vm._s(_vm.persons[0].fullname)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }